import { render } from "./AppLogoCenter.vue?vue&type=template&id=1d58c5e5"
import script from "./AppLogoCenter.vue?vue&type=script&lang=js"
export * from "./AppLogoCenter.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\danie\\Development\\expressivelabs\\store\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__